import { MeetingProviderAccountIntegrationConfig } from '../../models/Account'
import { RoomSession } from '../../models/Room'
import { useAppSelector } from '../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../store/auth/authSlice'
import React, { useMemo } from 'react'
import { parseMetadata } from '../../common/util'
import { ScopedBlock } from '../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../components/ScopedBlock/models'
import { Button } from '../../components/Button/Button'
import { useSessionAvailability } from '../../components/ScopedBlock/hooks'
import { supportedCallSolutions } from '../../common/integrations'

export interface StartCallButtonProps {
  phoneConfig: MeetingProviderAccountIntegrationConfig | null
  session: RoomSession
  onRoomSessionSelectedForCall?: (details: { session: RoomSession; doCall: boolean }) => void
}

export const StartCallButton: React.FC<StartCallButtonProps> = ({ phoneConfig, session, onRoomSessionSelectedForCall }) => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const { source } = useMemo(() => parseMetadata(session?.metadata ?? '{}'), [session])
  const provider = useMemo(() => {
    return supportedCallSolutions.find((integration) => integration.id === phoneConfig?.defaultProvider) ?? null
  }, [phoneConfig])
  const { available: sessionAvailable, isSuccess: sessionAvailabilitySuccess } = useSessionAvailability()
  const doCall = !!provider?.id && provider.id !== 'intulse'

  const atRoomSessionLimitActions = () => {
    return sessionAvailabilitySuccess && sessionAvailable
  }

  if (
    session?.roomCreatedBy?.id !== currentUserId ||
    source !== 'phone' ||
    !phoneConfig?.sharedPhoneLineEnabled ||
    session.isActive ||
    !session.finishedAt ||
    session.finishedAt <= new Date().toISOString() ||
    !onRoomSessionSelectedForCall
  ) {
    return null
  }

  return (
    <>
      <ScopedBlock
        scope={{
          scope: 'room_session:start',
          superScope: ['room_session:admin', 'room:admin'],
        }}
        authActions={[atRoomSessionLimitActions]}
        missingScopeAction={MissingScopeAction.DISABLE}
      >
        <Button variant='primary' className='button-small text-nowrap' onClick={() => onRoomSessionSelectedForCall({ session, doCall })}>
          {provider?.id !== 'intulse' ? 'Start Call' : 'Intulse Call'}
        </Button>
      </ScopedBlock>
    </>
  )
}
